/* =============================================================================
   JAPANSOLVED LANDING PAGE TEMPLATE v1 JS / FIXED28 PHASE A+B COMPATIBLE STABLE ENGINE
   Install target: assets/js-landing-page-v1.js
   Scope: [data-jslp-root] only.
   Behavior: 4-system hero controller, 3 slides each, dark/light + mobile/desktop switching,
   dots, autoplay, visibility pause, reduced-motion, Shopify editor reload safe destroy.
   ============================================================================= */
(function(){
  'use strict';
  var NS='JapanSolvedLandingPageV1';

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }

  function on(target,type,handler,options,cleanup){
    if(!target||!target.addEventListener) return;
    target.addEventListener(type,handler,options||false);
    if(cleanup) cleanup.push(function(){target.removeEventListener(type,handler,options||false);});
  }

  function reduced(){
    try{return !!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);}catch(e){return false;}
  }

  function idle(fn,timeout){
    if('requestIdleCallback' in window) window.requestIdleCallback(fn,{timeout:timeout||1800});
    else window.setTimeout(fn,220);
  }

  function extractBgUrl(slide){
    var raw=slide&&slide.style?slide.style.getPropertyValue('--jslp-bg')||'':'';
    var m=raw.match(/url\(["']?([^"')]+)["']?\)/i);
    return m?m[1]:'';
  }

  function preloadUrl(url,eager){
    if(!url||preloadUrl.done[url]) return;
    preloadUrl.done[url]=true;
    var img=new Image();
    img.decoding='async';
    if(eager) img.loading='eager';
    img.src=url;
    if(img.decode) img.decode().catch(function(){});
  }
  preloadUrl.done={};

  function initHero(root){
    if(!root) return;
    var instanceKey='__'+NS+'_'+(root.closest('[data-section-id]')?root.closest('[data-section-id]').getAttribute('data-section-id'):'main');
    if(window[instanceKey]&&window[instanceKey].destroy){try{window[instanceKey].destroy();}catch(e){}}

    var cleanup=[];
    var systems=Array.prototype.slice.call(root.querySelectorAll('[data-jslp-system]'));
    if(!systems.length) return;

    var reduce=reduced();
    var mobileMq=window.matchMedia?window.matchMedia('(max-width: 749px)'):null;
    var activeKey=null;
    var activeSystem=null;
    var timer=null;
    var manualTimer=null;
    var resizeTimer=null;
    var hidden=document.hidden;
    var hoverPaused=false;
    var state={};

    function slides(sys){return sys?Array.prototype.slice.call(sys.querySelectorAll('.jslp-slide')):[];}
    function dots(sys){return sys?Array.prototype.slice.call(sys.querySelectorAll('.jslp-dot')):[];}

    function getTheme(){
      var h=document.documentElement;
      var b=document.body;
      var hv=(h.getAttribute('data-js-theme')||h.getAttribute('data-theme')||'').toLowerCase();
      var bv=(b&&(b.getAttribute('data-js-theme')||b.getAttribute('data-theme')||'')||'').toLowerCase();
      var hc=(h.className||'').toString().toLowerCase();
      var bc=(b&&b.className||'').toString().toLowerCase();
      if(hv==='light'||bv==='light'||hc.indexOf('light')>-1||bc.indexOf('light')>-1||hc.indexOf('js-theme-light')>-1||bc.indexOf('js-theme-light')>-1) return 'light';
      if(hv==='dark'||bv==='dark'||hc.indexOf('dark')>-1||bc.indexOf('dark')>-1||hc.indexOf('js-theme-dark')>-1||bc.indexOf('js-theme-dark')>-1) return 'dark';
      return 'dark';
    }

    function getKey(){
      var theme=getTheme();
      var forcedDesktop=document.documentElement.getAttribute('data-js-view')==='desktop';
      var isMobile=mobileMq?mobileMq.matches&&!forcedDesktop:false;
      return (isMobile?'mobile':'desktop')+'-'+theme;
    }

    function durationFor(sys,index){
      var list=slides(sys);
      var fromSlide=list[index]?parseInt(list[index].getAttribute('data-duration'),10):0;
      var fromSystem=sys?parseInt(sys.getAttribute('data-interval'),10):0;
      return fromSlide||fromSystem||7600;
    }

    function buildDots(sys){
      var key=sys.getAttribute('data-jslp-system');
      var wrap=sys.querySelector('[data-jslp-dots]');
      var list=slides(sys);
      state[key]=state[key]||{index:0};
      if(!wrap) return;
      wrap.innerHTML='';
      list.forEach(function(_,index){
        var dot=document.createElement('button');
        dot.type='button';
        dot.className='jslp-dot';
        dot.setAttribute('aria-label','Go to hero slide '+(index+1));
        dot.addEventListener('click',function(){
          clearManual();
          clearTimer();
          paint(sys,index);
          manualTimer=window.setTimeout(function(){schedule(durationFor(sys,index));},reduce?0:920);
        });
        wrap.appendChild(dot);
      });
    }

    function warmAround(sys,index){
      var list=slides(sys);
      if(!list.length) return;
      preloadUrl(extractBgUrl(list[index]),true);
      idle(function(){preloadUrl(extractBgUrl(list[(index+1)%list.length]),false);},900);
    }

    function paint(sys,index){
      var list=slides(sys);
      var dotList=dots(sys);
      if(!list.length) return;
      var safe=((index%list.length)+list.length)%list.length;
      list.forEach(function(slide,i){
        var active=i===safe;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',active?'false':'true');
        if(active){
          var d=durationFor(sys,safe);
          slide.style.setProperty('--jslp-active-duration',d+'ms');
          preloadUrl(extractBgUrl(slide),true);
        }
      });
      dotList.forEach(function(dot,i){
        var active=i===safe;
        dot.classList.toggle('is-active',active);
        dot.setAttribute('aria-current',active?'true':'false');
      });
      state[sys.getAttribute('data-jslp-system')].index=safe;
      warmAround(sys,safe);
    }

    function clearTimer(){if(timer) window.clearTimeout(timer); timer=null;}
    function clearManual(){if(manualTimer) window.clearTimeout(manualTimer); manualTimer=null;}

    function schedule(delay){
      clearTimer();
      if(reduce||hidden||hoverPaused||!activeSystem) return;
      var key=activeKey;
      var current=state[key]?state[key].index||0:0;
      timer=window.setTimeout(function(){
        var list=slides(activeSystem);
        if(!list.length) return;
        var next=((state[key].index||0)+1)%list.length;
        paint(activeSystem,next);
        schedule(durationFor(activeSystem,next));
      },delay||durationFor(activeSystem,current));
    }

    function activate(force){
      var key=getKey();
      var sys=root.querySelector('[data-jslp-system="'+key+'"]')||systems[0];
      if(!sys) return;
      if(!force&&key===activeKey&&sys===activeSystem) return;
      activeKey=key;
      activeSystem=sys;
      systems.forEach(function(item){
        var isActive=item===sys;
        item.classList.toggle('is-system-active',isActive);
        item.setAttribute('aria-hidden',isActive?'false':'true');
      });
      state[key]=state[key]||{index:0};
      paint(sys,state[key].index||0);
      root.classList.add('is-ready');
      schedule(durationFor(sys,state[key].index||0));
    }

    function pointerEnter(){
      if(window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine)').matches){
        hoverPaused=true; clearTimer();
      }
    }
    function pointerLeave(){hoverPaused=false; schedule();}
    function visibility(){hidden=document.hidden; if(hidden) clearTimer(); else schedule(900);}
    function softResize(){window.clearTimeout(resizeTimer); resizeTimer=window.setTimeout(function(){activate(true);},220);}
    function themeOrViewChange(){activate(true);}

    systems.forEach(function(sys){
      var key=sys.getAttribute('data-jslp-system');
      state[key]=state[key]||{index:0};
      buildDots(sys);
      paint(sys,0);
    });

    on(root,'mouseenter',pointerEnter,false,cleanup);
    on(root,'mouseleave',pointerLeave,false,cleanup);
    on(document,'visibilitychange',visibility,false,cleanup);
    on(window,'resize',softResize,{passive:true},cleanup);
    on(window,'orientationchange',function(){window.setTimeout(softResize,260);},{passive:true},cleanup);
    on(window,'japansolved-theme-change',themeOrViewChange,false,cleanup);
    on(window,'japansolved-view-change',themeOrViewChange,false,cleanup);

    if(mobileMq&&mobileMq.addEventListener){mobileMq.addEventListener('change',themeOrViewChange); cleanup.push(function(){mobileMq.removeEventListener('change',themeOrViewChange);});}
    else if(mobileMq&&mobileMq.addListener){mobileMq.addListener(themeOrViewChange); cleanup.push(function(){mobileMq.removeListener(themeOrViewChange);});}

    var observer=null;
    if('MutationObserver' in window){
      observer=new MutationObserver(function(mutations){
        var should=false;
        mutations.forEach(function(m){
          if(m.type==='attributes'&&(m.attributeName==='data-js-theme'||m.attributeName==='data-js-view')) should=true;
        });
        if(should) activate(true);
      });
      observer.observe(document.documentElement,{attributes:true,attributeFilter:['data-js-theme','data-theme','data-js-view','class']});
      if(document.body){
        observer.observe(document.body,{attributes:true,attributeFilter:['data-js-theme','data-theme','class']});
      }
      cleanup.push(function(){observer.disconnect();});
    }

    window[instanceKey]={destroy:function(){
      clearTimer(); clearManual();
      cleanup.splice(0).forEach(function(fn){try{fn();}catch(e){}});
    }};

    activate(true);
  }

  function initAll(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-jslp-root]'),initHero);
  }

  ready(initAll);
  document.addEventListener('shopify:section:load',function(e){
    var root=e.target&&e.target.querySelector?e.target.querySelector('[data-jslp-root]'):null;
    if(root) initHero(root);
  });
  document.addEventListener('shopify:section:unload',function(){
    Object.keys(window).forEach(function(k){
      if(k.indexOf('__'+NS+'_')===0&&window[k]&&window[k].destroy){try{window[k].destroy();}catch(e){}}
    });
  });
})();


/* FIXED10: Soft section-by-section reveal for landing page body modules. */
(function(){
  'use strict';
  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }
  ready(function(){
    if(!document.querySelector('.jslp-body')) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      document.documentElement.classList.add('jslp-reveal-ready');
      document.querySelectorAll('.jslp-body .jslp-body-section,.jslp-body .jslp-helper-figure,.jslp-body .jslp-final-cta,.jslp-body .jslp-intake-accordion,.jslp-body .jslp-reveal').forEach(function(el){el.classList.add('is-revealed');});
      return;
    }
    document.documentElement.classList.add('jslp-reveal-ready');
    var items=Array.prototype.slice.call(document.querySelectorAll('.jslp-body .jslp-body-section,.jslp-body .jslp-helper-figure,.jslp-body .jslp-final-cta,.jslp-body .jslp-intake-accordion,.jslp-body .jslp-reveal'));
    if(!('IntersectionObserver' in window)){
      items.forEach(function(el){el.classList.add('is-revealed');});
      return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    },{root:null,rootMargin:'0px 0px -12% 0px',threshold:.12});
    items.forEach(function(el){io.observe(el);});
  });
})();


/* FIXED28 NOTE: Phase A+B hero synchronization remains Liquid-side.
   JS is intentionally stable to preserve autoplay, theme switching, dots, and reveal behavior. */

/* FIXED29: Live header "J" anchor for hero copy/mask across zoom levels. */
(function(){
  'use strict';

  function clamp(n,min,max){
    return Math.max(min, Math.min(max, n));
  }

  function visibleLogoLeft(){
    var selectors=[
      'header .header__heading-link',
      'header .header__heading',
      '.header__heading-link',
      '.header__heading',
      'header .site-header__logo',
      'header .header-logo',
      'header .logo',
      'header img[alt*="JapanSolved"]',
      'header a[href="/"]'
    ];

    for(var i=0;i<selectors.length;i++){
      var el=document.querySelector(selectors[i]);
      if(!el) continue;
      var r=el.getBoundingClientRect();
      if(r && r.width>60 && r.left>=0 && r.top<280){
        return r.left;
      }
    }

    return null;
  }

  function applyLiveJAnchor(root){
    if(!root) return;

    var rect=root.getBoundingClientRect();
    if(!rect || !rect.width) return;

    var logoLeft=visibleLogoLeft();
    var anchor;

    if(logoLeft!==null){
      anchor=Math.round(logoLeft-rect.left);
    }else{
      anchor=Math.round(Math.max(40,(rect.width-1200)/2));
    }

    var minAnchor=32;
    var maxAnchor=Math.max(minAnchor,rect.width-560);
    anchor=clamp(anchor,minAnchor,maxAnchor);

    root.style.setProperty('--jslp-live-j-anchor-x',anchor+'px');
    root.style.setProperty('--jslp-hero-copy-anchor-x',anchor+'px');
  }

  function applyAllLiveJAnchors(){
    Array.prototype.forEach.call(document.querySelectorAll('.jslp[data-jslp-page-template]'),applyLiveJAnchor);
  }

  var timer=null;
  function scheduleLiveJAnchor(){
    window.clearTimeout(timer);
    timer=window.setTimeout(function(){
      window.requestAnimationFrame(function(){
        applyAllLiveJAnchors();
        window.requestAnimationFrame(applyAllLiveJAnchors);
      });
    },40);
  }

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }

  ready(scheduleLiveJAnchor);
  window.addEventListener('load',scheduleLiveJAnchor);
  window.addEventListener('resize',scheduleLiveJAnchor,{passive:true});
  window.addEventListener('orientationchange',scheduleLiveJAnchor,{passive:true});
  window.addEventListener('japansolved-theme-change',scheduleLiveJAnchor);
  window.addEventListener('japansolved-view-change',scheduleLiveJAnchor);
  document.addEventListener('shopify:section:load',scheduleLiveJAnchor);

  if(window.visualViewport){
    window.visualViewport.addEventListener('resize',scheduleLiveJAnchor,{passive:true});
    window.visualViewport.addEventListener('scroll',scheduleLiveJAnchor,{passive:true});
  }

  if('MutationObserver' in window){
    var mo=new MutationObserver(scheduleLiveJAnchor);
    mo.observe(document.documentElement,{attributes:true,attributeFilter:['class','style','data-js-theme','data-js-view']});
    if(document.body){
      mo.observe(document.body,{attributes:true,attributeFilter:['class','style','data-js-theme']});
    }
  }
})();

/* =============================================================================
   FIXED39: Template-wide TEXT LUX Hover™ + Black Gallery Dark-Lux™ state sync
   Scope: .jslp-body only. Does not alter hero slideshow logic.
   Purpose: reliably adds .jslp-dark-view / .jslp-light-view so the late Liquid
   failsafe can beat page-level gray panels and keep headings readable at rest.
   ============================================================================= */
(function(){
  'use strict';

  var scheduled=false;

  function roots(){
    return Array.prototype.slice.call(document.querySelectorAll('.jslp-body'));
  }

  function isVisible(el){
    if(!el) return false;
    try{
      var st=window.getComputedStyle(el);
      if(st.display==='none'||st.visibility==='hidden'||Number(st.opacity)===0) return false;
      return !!(el.offsetWidth||el.offsetHeight||el.getClientRects().length);
    }catch(e){
      return true;
    }
  }

  function readModeText(el){
    if(!el) return '';
    return [
      el.innerText||'',
      el.textContent||'',
      el.getAttribute&&el.getAttribute('aria-label')||'',
      el.getAttribute&&el.getAttribute('title')||'',
      el.getAttribute&&el.getAttribute('data-theme')||'',
      el.getAttribute&&el.getAttribute('data-js-theme')||'',
      el.getAttribute&&el.getAttribute('data-color-scheme')||'',
      el.getAttribute&&el.getAttribute('data-mode')||''
    ].join(' ').replace(/\s+/g,' ').trim().toLowerCase();
  }

  function detectDark(){
    var html=document.documentElement;
    var body=document.body;
    var attr=[
      html.getAttribute('data-js-theme')||'',
      html.getAttribute('data-theme')||'',
      html.getAttribute('data-color-scheme')||'',
      html.getAttribute('data-mode')||'',
      body&&body.getAttribute('data-js-theme')||'',
      body&&body.getAttribute('data-theme')||'',
      body&&body.getAttribute('data-color-scheme')||'',
      body&&body.getAttribute('data-mode')||''
    ].join(' ').toLowerCase();

    var cls=((html.className||'')+' '+(body&&body.className||'')).toLowerCase();
    var dark = attr.indexOf('dark')>-1 || cls.indexOf('dark')>-1 || cls.indexOf('js-theme-dark')>-1;
    var light = attr.indexOf('light')>-1 || cls.indexOf('light')>-1 || cls.indexOf('js-theme-light')>-1;

    if(light && !dark) dark=false;

    var visibleLightAction=false;
    var visibleDarkAction=false;
    var possible=document.querySelectorAll('button,a,[role="button"],[aria-label],[title],.header__icon,.color-scheme-toggle,[class*="theme"],[class*="scheme"],[class*="mode"]');

    Array.prototype.forEach.call(possible,function(el){
      if(!isVisible(el)) return;
      var t=readModeText(el);
      if(!t) return;
      if(t==='light'||t.indexOf(' light ')>-1||t.indexOf('switch to light')>-1||t.indexOf('theme: light')>-1){visibleLightAction=true;}
      if(t==='dark'||t.indexOf(' dark ')>-1||t.indexOf('switch to dark')>-1||t.indexOf('theme: dark')>-1){visibleDarkAction=true;}
    });

    /* JapanSolved™ header button label is usually the available action.
       Visible LIGHT means current page is dark; visible DARK means current page is light. */
    if(visibleLightAction && !visibleDarkAction) dark=true;
    if(visibleDarkAction && !visibleLightAction) dark=false;

    return !!dark;
  }

  function sync(){
    scheduled=false;
    var dark=detectDark();
    roots().forEach(function(root){
      root.classList.toggle('jslp-dark-view',dark);
      root.classList.toggle('jslp-light-view',!dark);
    });
  }

  function schedule(){
    if(scheduled) return;
    scheduled=true;
    (window.requestAnimationFrame||window.setTimeout)(sync,0);
  }

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }

  ready(function(){
    sync();
    setTimeout(sync,80);
    setTimeout(sync,300);
    setTimeout(sync,900);
    window.addEventListener('load',schedule,{passive:true});
    window.addEventListener('japansolved-theme-change',schedule);
    window.addEventListener('japansolved-view-change',schedule);
    document.addEventListener('shopify:section:load',schedule);
    document.addEventListener('click',function(){
      setTimeout(schedule,30);
      setTimeout(schedule,180);
    },true);

    if('MutationObserver' in window){
      try{
        new MutationObserver(schedule).observe(document.documentElement,{
          attributes:true,
          childList:true,
          subtree:true,
          characterData:true,
          attributeFilter:['class','data-js-theme','data-theme','data-color-scheme','data-mode','aria-label','title','style']
        });
      }catch(e){}
    }
  });
})();

/* JAPANSOLVED™ Landing Heading Mobile Touch Glint v7.6.39 */
(function(){
  'use strict';
  var headingSelector='.jslp-body .jslp-title-xl,.jslp-body .jslp-title-lg,.jslp-body .jslp-title-md,.jslp-body .jslp-shine,.jslp-body h1,.jslp-body h2,.jslp-body h3';
  var cardSelector='.jslp-body .jslp-pain-card,.jslp-body .jslp-icon-card,.jslp-body .jslp-step,.jslp-body .jslp-faq-row,.jslp-body .jslp-product-card,.jslp-body .jslp-related-card,.jslp-body .jslp-arch-card,.jslp-body .jslp-door-map-card,.jslp-body .jslp-door-panel';

  function activate(el){
    if(!el || (el.closest && el.closest('#jslp-intake'))) return;
    el.classList.add('is-jslp-touch-glint');
    window.clearTimeout(el.__jslpTouchGlintTimer);
    el.__jslpTouchGlintTimer=window.setTimeout(function(){ el.classList.remove('is-jslp-touch-glint'); }, 2150);
  }

  function findTarget(target){
    if(!target || !target.closest) return null;
    return target.closest(headingSelector) || target.closest(cardSelector);
  }

  document.addEventListener('pointerdown', function(ev){ activate(findTarget(ev.target)); }, {passive:true});
  document.addEventListener('touchstart', function(ev){ activate(findTarget(ev.target)); }, {passive:true});
})();

/* =============================================================================
   JAPANSOLVED™ FIXED56 CLEAN HARMONIZED FULL JS SYSTEM
   Updated: 2026-06-30
   Full replacement for assets/js-landing-page-v1.js.
   Includes the former Liquid inline hero measurement/reflow scripts as hardwired asset behavior.
   ============================================================================= */


/* ---- MOVED FROM LIQUID INTO FULL JS ASSET: jslp-fixed41-hero-title-four-line-intelligence ---- */
(function(){
  'use strict';

  var MAX_LINES = 4;
  var LONG_TITLE_TRIGGER = 74;
  var badStarts = {
    'a':1,'an':1,'and':1,'or':1,'but':1,'of':1,'to':1,'for':1,'with':1,'without':1,
    'in':1,'on':1,'at':1,'by':1,'from':1,'through':1,'into':1,'the':1
  };
  var badEnds = {
    'and':1,'or':1,'but':1,'of':1,'to':1,'for':1,'with':1,'without':1,
    'in':1,'on':1,'at':1,'by':1,'from':1,'through':1,'into':1,'the':1,'not':1
  };

  function cleanText(text){
    return (text || '').replace(/\s+/g,' ').trim();
  }

  function htmlEscape(text){
    return String(text || '')
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }

  function wordKey(word){
    return String(word || '').toLowerCase().replace(/^[^a-z0-9]+|[^a-z0-9]+$/g,'');
  }

  function lineLength(words, start, end){
    var len = 0;
    for(var i=start;i<end;i++){
      len += words[i].length;
      if(i > start) len += 1;
    }
    return len;
  }

  function breakWords(words, parts){
    if(parts <= 1 || words.length <= 1) return [words.join(' ')];
    if(words.length <= parts) return words.slice();

    var total = lineLength(words, 0, words.length);
    var target = total / parts;
    var memo = {};

    function solve(index, remaining){
      var key = index + ':' + remaining;
      if(memo[key]) return memo[key];
      if(remaining === 1){
        return memo[key] = {
          score: Math.pow(lineLength(words,index,words.length) - target, 2),
          cuts: [words.length]
        };
      }

      var best = null;
      var minEnd = index + 1;
      var maxEnd = words.length - remaining + 1;

      for(var end=minEnd; end<=maxEnd; end++){
        var len = lineLength(words,index,end);
        var firstNext = wordKey(words[end]);
        var lastThis = wordKey(words[end-1]);
        var score = Math.pow(len - target, 2);

        if(badStarts[firstNext]) score += 70;
        if(badEnds[lastThis]) score += 95;
        if(/[,;:]$/.test(words[end-1] || '')) score -= 10;
        if(len < target * .48) score += 55;

        var rest = solve(end, remaining - 1);
        score += rest.score;

        if(!best || score < best.score){
          best = { score: score, cuts: [end].concat(rest.cuts) };
        }
      }
      return memo[key] = best;
    }

    var cuts = solve(0, parts).cuts;
    var lines = [];
    var start = 0;
    for(var c=0;c<cuts.length;c++){
      lines.push(words.slice(start, cuts[c]).join(' '));
      start = cuts[c];
    }
    return lines;
  }

  function splitSentences(text){
    var matches = cleanText(text).match(/[^.!?。！？]+[.!?。！？]?/g);
    return (matches || [text]).map(cleanText).filter(Boolean);
  }

  function allocateLines(sentences){
    if(sentences.length === 1) return [MAX_LINES];
    var totalLen = sentences.reduce(function(sum,s){ return sum + s.length; },0) || 1;
    var allocation = sentences.map(function(s){ return Math.max(1, Math.round((s.length / totalLen) * MAX_LINES)); });
    var sum = allocation.reduce(function(a,b){ return a+b; },0);

    while(sum > MAX_LINES){
      var dec = -1;
      for(var i=0;i<allocation.length;i++){
        if(allocation[i] > 1 && (dec < 0 || sentences[i].length < sentences[dec].length)) dec = i;
      }
      if(dec < 0) break;
      allocation[dec]--;
      sum--;
    }

    while(sum < MAX_LINES){
      var inc = 0;
      for(var j=1;j<allocation.length;j++){
        if(sentences[j].length / allocation[j] > sentences[inc].length / allocation[inc]) inc = j;
      }
      allocation[inc]++;
      sum++;
    }
    return allocation;
  }

  function balanceTitle(text){
    var sentences = splitSentences(text);
    var allocation = allocateLines(sentences);
    var lines = [];

    sentences.forEach(function(sentence, idx){
      var words = sentence.split(/\s+/).filter(Boolean);
      lines = lines.concat(breakWords(words, allocation[idx] || 1));
    });

    while(lines.length > MAX_LINES){
      var shortest = 0;
      for(var i=1;i<lines.length-1;i++){
        if(lines[i].length < lines[shortest].length) shortest = i;
      }
      var mergeIntoNext = shortest === 0 || (lines[shortest+1] && lines[shortest+1].length < lines[shortest-1].length);
      if(mergeIntoNext && lines[shortest+1]){
        lines[shortest+1] = cleanText(lines[shortest] + ' ' + lines[shortest+1]);
        lines.splice(shortest,1);
      } else if(lines[shortest-1]){
        lines[shortest-1] = cleanText(lines[shortest-1] + ' ' + lines[shortest]);
        lines.splice(shortest,1);
      } else {
        break;
      }
    }

    return lines.map(cleanText).filter(Boolean).slice(0, MAX_LINES);
  }

  function estimatedLines(title){
    var cs = window.getComputedStyle ? window.getComputedStyle(title) : null;
    if(!cs) return 0;
    var lh = parseFloat(cs.lineHeight);
    var fs = parseFloat(cs.fontSize) || 1;
    if(!lh || isNaN(lh)) lh = fs * 1.05;
    var h = title.getBoundingClientRect().height;
    return h ? Math.round(h / lh) : 0;
  }

  function processTitles(){
    document.querySelectorAll('.jslp-hero .jslp-title').forEach(function(title){
      if(!title.dataset.jslpFixed41OriginalText){
        title.dataset.jslpFixed41OriginalText = cleanText(title.textContent);
        title.dataset.jslpFixed41OriginalHtml = title.innerHTML;
      }

      var text = title.dataset.jslpFixed41OriginalText || cleanText(title.textContent);
      if(!text) return;

      var originalBreaks = (title.dataset.jslpFixed41OriginalHtml.match(/<br\s*\/?\s*>/gi) || []).length + 1;
      var measured = estimatedLines(title);
      var slide = title.closest('.jslp-slide');
      if(slide && slide.getAttribute('data-title-lock-protected') === 'true') return;

      var hasManualBreaks = originalBreaks > 1;
      var needsBalance = (!hasManualBreaks && (text.length >= LONG_TITLE_TRIGGER || measured > MAX_LINES)) || originalBreaks > MAX_LINES || measured > MAX_LINES;

      if(!needsBalance) return;

      var lines = balanceTitle(text);
      if(lines.length < 2) return;

      title.innerHTML = lines.map(function(line){
        return '<span class="jslp-title-line">' + htmlEscape(line) + '</span>';
      }).join('<br>');

      title.classList.add('is-jslp-balanced-title');
      title.setAttribute('data-jslp-title-balanced-lines', String(lines.length));

      if(slide){
        slide.classList.add('is-jslp-title-balanced');
        slide.setAttribute('data-jslp-title-balanced-lines', String(lines.length));
        if(text.length >= 96){
          slide.classList.add('is-jslp-title-balanced-xl');
        }
      }
    });
  }

  function schedule(){
    window.requestAnimationFrame(function(){
      processTitles();
      window.requestAnimationFrame(processTitles);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', schedule, {once:true});
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, {once:true});
  window.addEventListener('resize', schedule);
  if(document.fonts && document.fonts.ready){
    document.fonts.ready.then(schedule).catch(function(){});
  }
})();


/* =============================================================================
   FIXED55 / FIXED56 — ADAPTIVE HERO TYPOGRAPHY + THREE-LINE REFLOW GUARD
   Full-asset hardwire. This is not a patch-only script.
   ============================================================================= */
(function(){
  'use strict';

  var badStarts = {
    'a':1,'an':1,'and':1,'or':1,'but':1,'of':1,'to':1,'for':1,'with':1,'without':1,
    'in':1,'on':1,'at':1,'by':1,'from':1,'through':1,'into':1,'the':1
  };
  var badEnds = {
    'and':1,'or':1,'but':1,'of':1,'to':1,'for':1,'with':1,'without':1,
    'in':1,'on':1,'at':1,'by':1,'from':1,'through':1,'into':1,'the':1,'not':1
  };

  function toInt(value){
    var n = parseInt(value || '0', 10);
    return isNaN(n) ? 0 : n;
  }

  function cleanText(text){
    return String(text || '').replace(/\s+/g,' ').trim();
  }

  function htmlEscape(text){
    return String(text || '')
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }

  function wordKey(word){
    return String(word || '').toLowerCase().replace(/^[^a-z0-9]+|[^a-z0-9]+$/g,'');
  }

  function lineLength(words,start,end){
    var len = 0;
    for(var i=start;i<end;i++){
      len += words[i].length;
      if(i > start) len += 1;
    }
    return len;
  }

  function breakWords(words, parts){
    if(parts <= 1 || words.length <= 1) return [words.join(' ')];
    if(words.length <= parts) return words.slice();

    var total = lineLength(words, 0, words.length);
    var target = total / parts;
    var memo = {};

    function solve(index, remaining){
      var key = index + ':' + remaining;
      if(memo[key]) return memo[key];

      if(remaining === 1){
        return memo[key] = {
          score: Math.pow(lineLength(words, index, words.length) - target, 2),
          cuts: [words.length]
        };
      }

      var best = null;
      var minEnd = index + 1;
      var maxEnd = words.length - remaining + 1;

      for(var end=minEnd; end<=maxEnd; end++){
        var len = lineLength(words, index, end);
        var firstNext = wordKey(words[end]);
        var lastThis = wordKey(words[end-1]);
        var score = Math.pow(len - target, 2);

        if(badStarts[firstNext]) score += 70;
        if(badEnds[lastThis]) score += 95;
        if(/[,;:]$/.test(words[end-1] || '')) score -= 10;
        if(len < target * .48) score += 55;

        var rest = solve(end, remaining - 1);
        score += rest.score;

        if(!best || score < best.score){
          best = { score: score, cuts: [end].concat(rest.cuts) };
        }
      }

      return memo[key] = best;
    }

    var cuts = solve(0, parts).cuts;
    var lines = [];
    var start = 0;
    for(var c=0;c<cuts.length;c++){
      lines.push(words.slice(start, cuts[c]).join(' '));
      start = cuts[c];
    }

    return lines.map(cleanText).filter(Boolean);
  }

  function hasManualBreaks(title){
    return !!(title && title.querySelectorAll('br').length);
  }

  function hasRichMarkup(title){
    if(!title) return false;
    var html = title.dataset.jslpFixed55OriginalHtml || title.innerHTML || '';
    return /<(span|em|strong|i|b|small|mark|a)\b/i.test(html);
  }

  function estimateLines(title){
    if(!title || !window.getComputedStyle) return 0;
    var cs = window.getComputedStyle(title);
    var lh = parseFloat(cs.lineHeight);
    var fs = parseFloat(cs.fontSize) || 1;
    if(!lh || isNaN(lh)) lh = fs * 1.06;
    var h = title.getBoundingClientRect().height;
    return h ? Math.max(1, Math.round(h / lh)) : 0;
  }

  function copyFits(slide, copy){
    var slideRect = slide.getBoundingClientRect();
    var copyRect = copy.getBoundingClientRect();
    if(!slideRect.height || !copyRect.height) return true;

    var safeTop = slideRect.top + Math.max(42, slideRect.height * 0.075);
    var safeBottom = slideRect.bottom - Math.max(42, slideRect.height * 0.075);
    var maxStack = slideRect.height * 0.72;

    return copyRect.top >= safeTop && copyRect.bottom <= safeBottom && copyRect.height <= maxStack;
  }

  function isProtected(slide){
    return slide && slide.getAttribute('data-title-lock-protected') === 'true';
  }

  function targetLines(slide){
    var target = toInt(slide.getAttribute('data-title-target-lines') || slide.getAttribute('data-title-intended-lines') || slide.getAttribute('data-title-lines'));
    if(target) return target;
    var title = slide.querySelector('.jslp-title');
    var len = title ? cleanText(title.textContent).length : 0;
    if(len <= 44) return 2;
    if(len <= 86) return 3;
    if(len <= 126) return 4;
    return 5;
  }

  function pressureForTarget(target, seed){
    if(target === 2) return 'impact-2';
    if(target === 3) return 'impact-3';
    if(target === 4) return 'compact-4';
    if(target > 4) return 'compact-xl';
    return seed || 'standard';
  }

  function downgradePressure(pressure, target, measured){
    if(pressure === 'impact-2') return measured > 2 ? 'standard' : 'impact-2';
    if(pressure === 'impact-3') return measured > 3 ? 'standard' : 'impact-3';
    if(pressure === 'standard' && target >= 4) return 'compact-4';
    if(pressure === 'compact-4') return measured > 4 ? 'compact-xl' : 'compact-4';
    return pressure === 'compact-xl' ? 'compact-xl' : 'standard';
  }

  function resetTitle(title){
    if(!title) return;
    if(!title.dataset.jslpFixed55OriginalHtml){
      title.dataset.jslpFixed55OriginalHtml = title.innerHTML;
      title.dataset.jslpFixed55OriginalText = cleanText(title.textContent);
    }
    if(title.classList.contains('is-jslp-reflow-title')){
      title.innerHTML = title.dataset.jslpFixed55OriginalHtml;
      title.classList.remove('is-jslp-reflow-title');
      title.removeAttribute('data-jslp-title-reflow-lines');
    }
  }

  function reflowTitleIfSafe(slide, title, target){
    if(isProtected(slide) || !title) return false;
    if(target < 2 || target > 4) return false;

    resetTitle(title);

    if(hasManualBreaks(title)) return false;
    if(hasRichMarkup(title)) return false;

    var text = title.dataset.jslpFixed55OriginalText || cleanText(title.textContent);
    var words = text.split(/\s+/).filter(Boolean);
    if(words.length < target) return false;

    var shouldReflow = target === 3 || target === 2 || (target === 4 && text.length > 86);
    if(!shouldReflow) return false;

    var lines = breakWords(words, target);
    if(lines.length !== target) return false;

    title.innerHTML = lines.map(function(line){
      return '<span class="jslp-title-line">' + htmlEscape(line) + '</span>';
    }).join('<br>');

    title.classList.add('is-jslp-reflow-title');
    title.setAttribute('data-jslp-title-reflow-lines', String(lines.length));
    slide.classList.add(target === 3 ? 'is-jslp-three-line-reflow' : 'is-jslp-target-line-reflow');
    return true;
  }

  function processSlide(slide){
    if(isProtected(slide)) return;

    var title = slide.querySelector('.jslp-title');
    var copy = slide.querySelector('.jslp-copy');
    if(!title || !copy) return;

    if(!slide.getAttribute('data-title-pressure-seed')){
      slide.setAttribute('data-title-pressure-seed', slide.getAttribute('data-title-pressure') || 'standard');
    }

    var seed = slide.getAttribute('data-title-pressure-seed') || 'standard';
    var target = targetLines(slide);
    var pressure = pressureForTarget(target, seed);

    slide.classList.remove('is-jslp-hero-pressure-downgraded');
    slide.classList.remove('is-jslp-impact-guarded');
    slide.classList.remove('is-jslp-three-line-reflow');
    slide.classList.remove('is-jslp-target-line-reflow');
    slide.classList.remove('is-jslp-width-boosted');

    slide.setAttribute('data-title-target-lines', String(target));
    slide.setAttribute('data-title-pressure', pressure);

    reflowTitleIfSafe(slide, title, target);

    if(target === 3){
      slide.classList.add('is-jslp-width-boosted');
    }

    var measured = estimateLines(title);
    slide.setAttribute('data-title-lines-measured', String(measured || target || 1));

    var tooManyLines = false;
    if(pressure === 'impact-2' && measured > 2) tooManyLines = true;
    if(pressure === 'impact-3' && measured > 3) tooManyLines = true;
    if(pressure === 'compact-4' && measured > 4) tooManyLines = true;

    var tooTall = !copyFits(slide, copy);

    if(tooManyLines || tooTall){
      var safer = downgradePressure(pressure, target, measured);
      slide.setAttribute('data-title-pressure', safer);
      slide.classList.add('is-jslp-hero-pressure-downgraded');
      slide.classList.add('is-jslp-impact-guarded');

      if(tooManyLines && safer === 'standard'){
        resetTitle(title);
      }

      window.requestAnimationFrame(function(){
        var after = estimateLines(title);
        slide.setAttribute('data-title-lines-measured', String(after || measured || target || 1));
        if(!copyFits(slide, copy) && safer !== 'compact-xl'){
          slide.setAttribute('data-title-pressure', 'compact-xl');
          slide.classList.add('is-jslp-hero-pressure-downgraded');
        }
      });
    }
  }

  function process(){
    document.querySelectorAll('.jslp-hero .jslp-slide').forEach(processSlide);
  }

  function schedule(){
    window.requestAnimationFrame(function(){
      process();
      window.requestAnimationFrame(process);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', schedule, {once:true});
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, {once:true});
  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('orientationchange', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  if(document.fonts && document.fonts.ready){
    document.fonts.ready.then(schedule).catch(function(){});
  }
})();



/* ---- MOVED FROM LIQUID INTO FULL JS ASSET: jslp-v7639-hero-gold-preservation-after-fixed41 ---- */
(function(){
  'use strict';

  function esc(str){
    return String(str == null ? '' : str).replace(/[&<>"']/g,function(s){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[s];
    });
  }
  function cleanText(text){ return String(text || '').replace(/\s+/g,' ').trim(); }

  function collectGoldRanges(title){
    var html = title.dataset.jslpFixed41OriginalHtml || title.innerHTML || '';
    var text = title.dataset.jslpFixed41OriginalText || cleanText(title.textContent);
    if(!html || !text) return [];
    var box = document.createElement('div');
    box.innerHTML = html;
    var ranges = [];
    var cursor = 0;
    box.querySelectorAll('.jslp-gold,.jslp-yellow-gold,.jslp-phrase-gold,[data-jslp-gold]').forEach(function(node){
      var phrase = cleanText(node.textContent);
      if(!phrase) return;
      var idx = text.indexOf(phrase, cursor);
      if(idx < 0) idx = text.indexOf(phrase);
      if(idx >= 0){
        ranges.push({start:idx,end:idx+phrase.length});
        cursor = idx + phrase.length;
      }
    });
    ranges.sort(function(a,b){ return a.start-b.start || b.end-a.end; });
    return ranges;
  }

  function lineHtml(line, lineStart, ranges){
    var out = '';
    var pos = 0;
    var lineEnd = lineStart + line.length;
    ranges.forEach(function(r){
      var s = Math.max(r.start, lineStart);
      var e = Math.min(r.end, lineEnd);
      if(e <= s) return;
      var localS = s - lineStart;
      var localE = e - lineStart;
      if(localS > pos) out += esc(line.slice(pos, localS));
      out += '<span class="jslp-gold" data-jslp-gold="true">' + esc(line.slice(localS, localE)) + '</span>';
      pos = localE;
    });
    if(pos < line.length) out += esc(line.slice(pos));
    return out || esc(line);
  }

  function restoreTitle(title){
    if(!title || title.closest('#jslp-intake')) return;
    var ranges = collectGoldRanges(title);
    if(!ranges.length) return;
    var full = title.dataset.jslpFixed41OriginalText || cleanText(title.textContent);
    var cursor = 0;
    var lines = Array.prototype.slice.call(title.querySelectorAll('.jslp-title-line'));
    if(!lines.length) return;
    lines.forEach(function(line){
      var txt = cleanText(line.textContent);
      if(!txt) return;
      var start = full.indexOf(txt, cursor);
      if(start < 0) start = cursor;
      line.innerHTML = lineHtml(txt, start, ranges);
      cursor = start + txt.length + 1;
    });
    title.classList.add('is-jslp-gold-preserved');
  }

  function run(){
    document.querySelectorAll('.jslp-hero .jslp-title').forEach(restoreTitle);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {once:true});
  else run();
  window.addEventListener('load', run, {once:true});
  window.addEventListener('resize', function(){ window.requestAnimationFrame(run); }, {passive:true});
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(run).catch(function(){});
})();
